import { Redirect, useLocalSearchParams } from 'expo-router';
import { ScrollView, View } from 'react-native';

import { ResetPasswordForm } from '@/components/reset-password-form';

export default function ResetPasswordScreen() {
  const { email } = useLocalSearchParams<{ email?: string }>();

  if (!email) {
    return <Redirect href="/(public)/forgot-password" />;
  }

  return (
    <ScrollView
      keyboardShouldPersistTaps="handled"
      contentContainerClassName="items-center justify-center p-4 py-8 sm:flex-1 sm:p-6 sm:py-4"
      contentInsetAdjustmentBehavior="automatic"
      keyboardDismissMode="interactive"
      className="flex-1 bg-background"
    >
      <View className="w-full max-w-sm">
        <ResetPasswordForm email={email} />
      </View>
    </ScrollView>
  );
}
